module.exports = __webpack_public_path__ + "files/86feabc255aa7e9f7376e2878727a411.svg";